import { render, staticRenderFns } from "./TheHomeScreen.vue?vue&type=template&id=5d336c8d&"
import script from "./TheHomeScreen.vue?vue&type=script&lang=js&"
export * from "./TheHomeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports